import React from 'react';
import { withWebView } from '../hoc/withWebView';
import PrivacyContent from '../components/PrivacyContent';

export default withWebView(PrivacyContent, 'privacy'); 